import { Autocomplete, Grid, TextField } from '@mui/material'
import { useContext, useEffect, useState } from 'react'

import styles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'
import globalStyles from './../../../../assets/styles/global.module.scss'

import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext'
import { UserContext, UserContextPayload } from '../../../../context/userContext'
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext'
import { Refresh } from '@mui/icons-material'
import { renderIntegrationOption } from '../workflowConstants'
import { filterAutocompleteOptionsWithException } from '../../../../utils/constants'
import { metIntegrationInstagramDataNew } from '../../../../models/axiosModel'

const WorkflowInstagramIntegration = () => {
    
    const { setFlagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload
    const { integrationListNewStructure, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { createNewWorkflowPayload, setCreateNewWorkflowPayload } = useContext(WorkflowContext) as WorkflowContextPayload

    const [selectedInstagramAccount, setSelectedInstagramAccount] = useState<metIntegrationInstagramDataNew | null>(null);

    const onChangeOfInstagramAccount = (value: metIntegrationInstagramDataNew | null) => {
        setSelectedInstagramAccount(value);
        setCreateNewWorkflowPayload({
            ...createNewWorkflowPayload,
            chatbot_channel_configuration: value ? {
                ...createNewWorkflowPayload.chatbot_channel_configuration, 
                meta_integration_instagram_id: Number(value?.meta_integration_instagram_id),
                integrated_channel_id: value?.integrated_channel_id,
            } : createNewWorkflowPayload?.chatbot_channel_configuration?.channel_content_type_id ? {
                channel_content_type_id: createNewWorkflowPayload?.chatbot_channel_configuration?.channel_content_type_id
            } : null
        })
    }

    const getIntegrationListApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await getMetaIntegrationList(true)
        if (res.status) {
        } else {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    // Instagram Business Account List
    let defaultObj = {
        instagram_account_name: "default",
        channel_name: "Instagram",
        meta_integration_instagram_id: -1,
    }

    function getInstagramBusinessAccounts() {
        
        let defaultAccount: any = [defaultObj]
        
        if (integrationListNewStructure) {
            let instagramAccounts = integrationListNewStructure.filter((list: any) => list.channel_name?.toLowerCase() === "instagram");
            defaultAccount = [...instagramAccounts, defaultObj];
        }

        return defaultAccount;
    }

    // Effects
    useEffect(() => {
        if (integrationListNewStructure !== null) return;
        (async () => {
            await getIntegrationListApiCall();
        })()
    }, [])

    return (
        <Grid item>
            <Grid container gap={"15px"}>
                
                <Grid item sx={{ width: "100%" }}>
                    <Grid container direction={"column"} gap={"10px"}>
                        
                        <Grid item className={`${styles.createWorkflowLabelStyle} ${styles.createWorkflowFieldLabelRow}`}>
                            Instagram Account
                            <Refresh onClick={getIntegrationListApiCall} className={styles.refreshIcon} />
                        </Grid>

                        <Grid item>
                            <Autocomplete
                                className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                options={getInstagramBusinessAccounts()}
                                getOptionLabel={(option: any) => option.instagram_account_name ? option.instagram_account_name : "Instagram Account"}
                                value={selectedInstagramAccount}
                                onChange={(_, value: any) => { onChangeOfInstagramAccount(value); }}
                                renderInput={(params) => <TextField {...params} placeholder="Select Instagram Account" />}
                                sx={{ padding: "2px 4px !important" }}
                                renderOption={(props, option) => renderIntegrationOption(props, option, "Instagram")}
                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "instagram_account_name", "meta_integration_instagram_id")}
                            />
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}

export default WorkflowInstagramIntegration;
